<label [for]="for" [ngClass]="{'text-error' : model?.invalid}">{{label}}
  <span *ngIf="model?.invalid">*</span>
</label>
